
import { Component, Vue } from "vue-property-decorator";

import PiOrderDetail from "./order-detail.vue";
import { objAny } from "../../../../common/common-interface";
import {
  getOrderDetail,
  getOfflineCardDetails
} from "@/api/api-charge-service";
import chargeCurve from "@/views/operation-analysis/site-monitor/components/children/charge-curve.vue";
import tempCurve from "@/views/operation-analysis/site-monitor/components/children/temp-curve.vue";
//import { objAny } from "@/common/common-interface";
import infoTitle from "@/components/info-title/info-title.vue";
import tabsContent from "@/components/tabs-content/tabs-content.vue";
import billingDataEchartLine from "./billing-data-echart-line.vue";
import chargeOrderTable from "./charge-order-table.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    PiOrderDetail,
    chargeCurve,
    tempCurve,
    billingDataEchartLine,
    "pi-info-title": infoTitle,
    "pi-tabs-content": tabsContent,
    "pi-charge-order-table": chargeOrderTable
  }
})
export default class PiChargeOrderDetail extends Vue {
  private tabsTitle = i18n.t("orderDetails.aorderDetailsTitle");
  private pageTabsList: objAny[] = [
    { title: this.tabsTitle, value: "1" },
    { title: i18n.t("orderDetails.orderCheckDetails"), value: "2" }
  ];
  private pageTabsActive = "1";
  private pageTab2 = false;
  private pageType = "";
  private tabsList: objAny[] = [
    { title: i18n.t("orderDetails.chargeDataEchart"), value: "1" }
  ];
  private tabsActive = "1";
  isLoaded = false;
  // CurveTypeEnum = CurveTypeEnum;
  // currentTab = CurveTypeEnum.CHARGE_CURVE;
  formInline: objAny = {};

  public tabChange(val: string): void {
    this.tabsActive = val;
  }
  public pageTabChange(val: string): void {
    if (val == "2" && !this.pageTab2) {
      this.pageTab2 = true;
    }
    this.pageTabsActive = val;
  }
  async getDetail() {
    let ret;
    if (this.pageType == "offOrder") {
      ret = await getOfflineCardDetails({ orderNo: this.formInline.orderNo });
    } else {
      ret = await getOrderDetail({ orderNo: this.formInline.orderNo });
    }
    if (ret.status == this["$config"].apiStatus) {
      this.formInline = ret.data[0];

      this.isLoaded = true;
      if (this.formInline.deviceType != 2) {
        this.tabsList.push({
          title: i18n.t("orderDetails.batteryEchart"),
          value: "2"
        });
      }
    }
  }
  created() {
    this.pageType = this["$common"].request("type");
    if (this.$route.query.orderNo) {
      this.formInline.orderNo = this.$route.query.orderNo;
      this.getDetail();
    }
    const localData = this["$common"].get("charge-order-list-item");
    if (localData) {
      this.formInline.orderNo = localData.orderNo;
      this.tabsList = [
        { title: i18n.t("orderDetails.chargeDataEchart"), value: "1" }
        // { title: i18n.t("orderDetails.chargeMoneyEchart"), value: "3" }
      ];
      this.tabsList.push({
        title: i18n.t("orderDetails.chargeMoneyEchart"),
        value: "3"
      });
      this.getDetail();
    }
  }
}
